module.exports = "/_next/static/images/img-map-2a23910f32ff9402b506838b21335a2d.png";